import React from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import SubmitRubriqTestimonialContainer from './components/SubmitRubriqTestimonialContainer';
export var Routes = function Routes() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: "submit-rubriq",
    element: /*#__PURE__*/React.createElement(SubmitRubriqTestimonialContainer, null)
  })));
};
export default Routes;